import { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import CustomForm from '../../../../core/components/core/Util/Form/CustomForm/CustomForm';
import CustomFormContainer from '../../../../core/components/core/Util/Form/CustomForm/CustomFormContainer';
import config from '../../../config/config';
import Fetch from "../../../../core/util/core/Fetch";
import { chooseProfileFilter } from "../../../helpers/chooseProfileFilter";

function Form() {
    const [formContent, setFormContent] = useState(<>Carregando...</>);
    const { id } = useParams();

    const profileFilter = chooseProfileFilter();

    const hiddenValues = {}

    if (profileFilter.pdc_entity_id) {
        hiddenValues.pdc_entity_id = profileFilter.pdc_entity_id
    }

    const path = '/principals/';
    const paths = {
        endpointSave: config.endpoints.backend + 'principals/save',
        endpointGetById: config.endpoints.backend + 'principals/getById',
        endpointGetAllEntities: config.endpoints.backend + 'entities/getall',
        endpointGetRoles: config.endpoints.backend + 'roles/getall',
        endpointGetProfessions: config.endpoints.backend + 'professions/getall',

        urlGoBack: path + 'list',
        pathView: path + 'view'
    }

    const labels = {
        labelTitleAdd: "Novo Dirigente",
        labelTitleEdit: "Editar Dirigente",
        labelTitleView: 'Visualizar Dirigente'
    }

    const getForm = (values) => {
        let form = {
            validateOnChange: true,
            hiddenValues: {
                ...hiddenValues
            },
            fields: [
                !hiddenValues.pdc_entity_id ? {
                    name: 'pdc_entity_id',
                    type: 'select',
                    label: 'Entidade',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetAllEntities,
                        label: 'corporate_name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: false
                    },
                    columnSize: 12,
                } : {},
                {
                    name: 'name',
                    type: 'text',
                    label: 'Nome',
                    validations: {
                        required: true
                    },
                    columnSize: 12
                },
                {
                    name: 'pdc_role_id',
                    type: 'select',
                    label: 'Função',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetRoles,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'pdc_profession_id',
                    type: 'select',
                    label: 'Profissão',
                    options: [],
                    optionsEndpoint: {
                        endpoint: paths.endpointGetProfessions,
                        label: 'name',
                        value: 'id',
                        params: {
                            filter: {
                                ...profileFilter
                            }
                        }
                    },
                    validations: {
                        required: true
                    },
                    columnSize: 12,
                },
                {
                    name: 'validity_start',
                    type: 'date',
                    label: 'Início da Vigência',
                    validations: {
                        required: true
                    },
                    columnSize: 6
                },
                {
                    name: 'validity_end',
                    type: 'date',
                    label: 'Fim da Vigência',
                    validations: {
                        required: false
                    },
                    columnSize: 6
                }
            ],
            ...paths,
            ...labels
        }
        form.values = values;
        return form;
    }

    useEffect(() => {
        const load = async () => {
            let values = {};

            if (id) {
                values = await Fetch.post(paths.endpointGetById, { id: id })
            }

            const form = getForm(values);
            setFormContent(
                <CustomFormContainer
                    form={form}
                    content={<CustomForm form={form} />}
                />
            )
        }
        load();
    }, [])

    return (
        <div>
            {formContent}
        </div>
    );
}
export default Form;
